<span
  class="svg-icon"
  [style.width]="size"
  [style.height]="size"
  [style.color]="color || null"
  [innerHTML]="svg">
</span>
